var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_22",
    "data-name": "Groupe 22",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.936,
    height: 22.074,
    viewBox: "0 0 21.936 22.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M254.573,36.091v-.034l-.022.034Z",
    transform: "translate(-242.777 -26.134)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M234.2,1.783H215.5a1.6,1.6,0,0,0-1.621,1.581V22.276a1.6,1.6,0,0,0,1.621,1.581H234.2a1.6,1.6,0,0,0,1.621-1.581V3.364A1.6,1.6,0,0,0,234.2,1.783ZM220.532,20.262h-3.313V10.294h3.313ZM218.876,8.933h-.022a1.893,1.893,0,1,1,.022,0Zm13.6,11.329h-3.313V14.929c0-1.34-.48-2.254-1.679-2.254a1.814,1.814,0,0,0-1.7,1.212,2.274,2.274,0,0,0-.109.809v5.566h-3.313s.043-9.033,0-9.968h3.313v1.412a3.288,3.288,0,0,1,2.986-1.646c2.18,0,3.814,1.425,3.814,4.486Z",
    transform: "translate(-213.883 -1.783)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.915e940c3fd98c93cca20c828006ce16.svg";
export { ForwardRef as ReactComponent };